export default __webpack_public_path__ + "static/media/Miscellaneous03.6ca5c33f.jpg";